import TimelineContainer from 'common/timeline/containers/timeline-container';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';
import { referenceTypes } from '../../utils/app-configs';

const FunctionalLocationTimeline = ({ id, renderMenu, ...rest }) => {
  const params = useParams();
  return <>
    <TimelineContainer
      id={id}
      type={referenceTypes.functionallocation}
      jumpToDate={
        params.filtervalue
          ? null
          : params.jumpToDateOrFilter
      }
      activeFilter={
        params.filtervalue && params.jumpToDateOrFilter
      }
      activeFilterValue={params.filtervalue}
      canCreateTicket={true}
      canCreateOrder={true}
      renderMenu={renderMenu}
      {...rest}
    />
  </>;
};
FunctionalLocationTimeline.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default FunctionalLocationTimeline;
